/**
 * PaymentSettle — 사용자PC(/u/orders) 오더 상세팝업의 수금/결제 상태 처리.
 *
 * 레거시와의 관계
 * ───────────────
 * 기존 public/js/u-order-list.js 의 수금/결제 관련 전역함수를 이관했다(세금/다중발행 코어 슬라이스 F).
 *   - payTypeSetToNew    : 결제방식(싸인/직수/카드) 변경 → 서버반영 후 목록 갱신
 *   - payat_misoocheck   : "미설정" 선택 시 수금액 0 처리
 *   - pstCh              : 수금상태 라디오(현금/은행/카드) 이미지 토글
 *   - payOkset           : 수금됨 상태 강제 체크
 *   - base_priceput_new  : 금액 입력칸 기본값 채움 + 미수금/합계 재계산 트리거
 *   - get_lastMisoo      : 총금액 − 수금액 = 미수금 계산
 *   - get_number_only    : "1,000" 형태 문자열 → 정수
 *   - multiPle_priceTotalGetShow : 묶음오더 계산서 금액 합계/세액 재계산
 *
 * 데드코드 정리(이관하지 않고 제거): payTypeSetTo / base_priceput / get_lastMisoo__notSet /
 *   cash_pay_check — 전 저장소에서 호출처 0. 각각 _new/get_lastMisoo 로 대체된 구버전이다.
 *
 * 구조: 모듈 스코프 자유함수 + 얇은 브리지 클래스.
 *   - 내부 상호호출(base_priceput_new → multiPle_priceTotalGetShow / get_lastMisoo)은 모듈 스코프로 해소.
 *   - 외부 전역(number_format, IntvalGet, get_orders(window 브리지), orderTax(window), $)은 bare 로 전역 해소.
 *     IntvalGet 은 아직 u-order-list.js(다중발행 슬라이스 B)에 있어 전역 함수로 남아있다 → bare 동작.
 *
 * 서버: POST /u/ajax/order/{onum}/howtopay
 */
import Util from '../../../Common/Util';

/**
 * 결제방식을 변경한다.
 * @param howtopay 1(싸인) 2(직수) 5(카드)
 */
function payTypeSetToNew(howtopay){
    let order_info = orderTax.get_current_order_info();
    var adr=`/u/ajax/order/${order_info.onum}/howtopay`;
    var sendData = {
        "howtopay":howtopay,
    };
    $.ajax({type:"POST",url:adr,data:sendData,dataType:'json',success:function(data){
        if( data.result) {
            get_orders();
        }else{
            $('#baltype'+order_info.pay_method).prop('checked',true);// 원래의 라디오 버튼이 다시 선택되도록 하라.
            alert(data.message);
        }
    }});

}

function payat_misoocheck(){
    if( document.getElementById("payed_status1").checked == true){
        document.getElementById("paystate_payedtoto").value = 0;
    }
}

function get_lastMisoo(){
    var payStRdoB = document.getElementById("payStRdoB");
    if( payStRdoB){
    }else{

    }
    var p1 = document.getElementById("paystate_worktotal").value;
    var p2 = document.getElementById("paystate_payedtoto").value;
    var p3 =document.getElementById("paystate_misoo");
    p1 = p1.replace(/,/gi,"");
    p2 = p2.replace(/,/gi,"");
    p1 = parseInt(p1,10);
    p2 = parseInt(p2,10);
    if( isNaN(p1)) p1 = 0;
    if( isNaN(p2)) p2 = 0;
    var n = Util.formatNumber(parseInt(p1 - p2));
    p3.value= n;
    //if( p2 > 0 && document.getElementById("payed_status3").checked != true){
    //document.getElementById("payed_status2").checked = true;
    //}
}

function get_number_only(nums){
    var ret = nums.replace(/,/gi,"");
    ret = parseInt(ret,10);
    if( isNaN(ret)) ret = 0;
    return ret;
}

function base_priceput_new(tar,pp, act){
    console.log(`${tar}, ${pp}, ${act}`);// bal_gotbill_price, 660000, undefined
    var obj = document.getElementById(tar);
    if( act == undefined) act = "";
    var n =Util.formatNumber(pp);
    if( obj.value == "0" || obj.value=="" || obj.value == 0  ){
        obj.value=n;
        obj.setAttribute("value", n);
    }
    if( act == "stop") return;
    // var cc = document.getElementById("billPrice");
    if( tar == "billPrice"){
        document.getElementById("paystate_worktotal").value = n;
        return;
    }

    if( tar == "paystate_payedtoto") {
        var thisCarorginprice = parseInt(document.getElementById("thisCarorginprice").value);
        if( document.getElementById("billstatus_2").checked==true || document.getElementById("billstatus_1").checked==true ){
            thisCarorginprice = parseInt( thisCarorginprice + ( thisCarorginprice * 0.1));
        }
        document.getElementById("paystate_payedtoto").value = Util.formatNumber(thisCarorginprice);
        if(document.getElementById("payed_status2").checked==true){
            document.getElementById("cardpaystatus").style.display="none";
        }
        if( document.getElementById("payed_status2").checked==true ){
            if( document.getElementById("paystae_where").value == ""){
                document.getElementById("paystae_where").value = document.getElementById("reciver_coname").innerHTML;
            }
        }
    }
    if( document.getElementById("popBizFormlist") && $.inArray(tar,['bal_gotbill_price','bal_gave_price'])==-1 ){
        multiPle_priceTotalGetShow();
        document.getElementById("paystate_payedtoto").value = document.getElementById("billPrice").value;
        get_lastMisoo();
        return;
    }
    get_lastMisoo();
}

/**
 * '수금완료 푸시 보내지 않음' 체크박스 — 수금됨(payed_status2)일 때만 보인다.
 * 현금·은행은 payOkset() 이 payed_status2 를 코드로만 체크해 click 이벤트가 안 뜨므로,
 * 라디오에 핸들러를 걸지 않고 상태를 바꾸는 함수들이 끝에서 이걸 불러 현재 체크 상태에 맞춘다.
 */
function syncSilentPush(){
    var w = document.getElementById("silent_push_wrap"), c = document.getElementById("silent_push"), r = document.getElementById("payed_status2");
    if( !w || !c || !r ) return;
    w.style.display = r.checked ? "block" : "none";
    if( !r.checked ) c.checked = false;
}

function pstCh(act){
    var m = document.popupSetDivForm;
    if( act == 1 ) document.getElementById("payed_status2").click();
    var mm = parseInt(m.paystate.value);
    if( isNaN(mm)) mm = 0 ;
    document.getElementById("payStRdoA").src="/img/m/radio_billstatus_unchecked_25_emp.png";
    document.getElementById("payStRdoB").src="/img/m/radio_billstatus_unchecked_25_emp.png";
    document.getElementById("payStRdoC").src="/img/m/radio_billstatus_unchecked_25_emp.png";
    document.getElementById("payStRdoD").src="/img/m/radio_billstatus_unchecked_25_emp.png";

    if( mm == 0 ) document.getElementById("payStRdoA").src="/img/m/radio_billstatus_checked_25.png";
    if( mm == 3 ) document.getElementById("payStRdoD").src="/img/m/radio_billstatus_checked_25.png";
    syncSilentPush();
    if( mm != 3 ){
        if( document.getElementById("cheked_by_cash").checked==true ) {
            document.getElementById("payStRdoB").src="/img/m/radio_billstatus_checked_25.png";
            document.getElementById("payStRdoA").src="/img/m/radio_billstatus_unchecked_25_emp.png";
        }
        if( document.getElementById("cheked_by_bank").checked==true ) {
            document.getElementById("payStRdoC").src="/img/m/radio_billstatus_checked_25.png";
            document.getElementById("payStRdoA").src="/img/m/radio_billstatus_unchecked_25_emp.png";
        }
    }
}

function payOkset(){
    document.getElementById("payed_status2").checked=true;
    syncSilentPush();
}

/**
 * 묶음오더 목록에서 계산서 금액 합계
 */
function multiPle_priceTotalGetShow(){
    if(document.getElementById("billstatus_1").checked == true) return;
    var obj = document.getElementById("popBizFormlist");
    var inputs = obj.getElementsByTagName("INPUT");
    var soo = 0, bal = 0;
    var isRelated = 0;
    var wprice = 0;
    var multiInCnt = 0;
    if( document.getElementById("multiCListBaljooTh") ) isRelated = 1;
    console.log('isRelated',isRelated);
    for (var i=0; i < inputs.length ; i++ ){
        if ( inputs[i].type == "checkbox"){
            var taxnum = IntvalGet(inputs[i].getAttribute("taxnum"));
            console.log('taxnum',taxnum);
            var ordernum = IntvalGet(inputs[i].getAttribute("value"));
            var carprice = IntvalGet(inputs[i].getAttribute("data-attr"));
            var sooprice = IntvalGet(inputs[i].getAttribute("sooprice"));
            var balprice = IntvalGet(inputs[i].getAttribute("balPrice"));
            var isch = inputs[i].checked;
            if( isch == true &&  taxnum > 1 && ordernum > 1 ){
                soo = parseInt( soo + sooprice);
                bal = parseInt( bal + balprice);
                wprice = parseInt( wprice + carprice );
                multiInCnt++;
            }
        }
    }
    console.log('sooprice', sooprice);
    console.log('balprice', balprice);

    document.getElementById("multi_print_cnt").value = multiInCnt;
    var OKN = IntvalGet(document.getElementById("paystate_payedtoto").value);
    if( isRelated == 1 ){
        var ss = parseInt( soo - bal);
        var ssSub = parseInt( soo - bal);
        var sooTax = 0 , balTax = 0;
        if( soo > 0 ) sooTax = parseInt( soo + parseInt( soo * 0.1));
        if( bal > 0 ) balTax = parseInt( bal + parseInt( bal * 0.1));
        var TTS = parseInt( sooTax -  balTax );
        if( document.getElementById("billstatus_5").checked == true) TTS = soo;

        var TTT = IntvalGet(TTS - OKN);
        var TaxTotal = parseInt( ssSub * 0.1);
        if( TaxTotal < 0 ) TaxTotal = 0;
        document.getElementById("totalTax").value = Util.formatNumber(TaxTotal);
        document.getElementById("billPrice").value = Util.formatNumber(sooTax);
        document.getElementById("paystate_worktotal").value = Util.formatNumber(TTS); ///// 총금액자리
        document.getElementById("paystate_misoo").value = Util.formatNumber(TTT);
        document.getElementById("multiFormTd_sprice").innerHTML = Util.formatNumber(soo);
        if(document.getElementById("multiFormTd_bprice")) document.getElementById("multiFormTd_bprice").innerHTML = Util.formatNumber(bal);
        if(document.getElementById("multiFormTd_after")) document.getElementById("multiFormTd_after").innerHTML = Util.formatNumber(ssSub);
    }else{
        var sooTax = parseInt( wprice + parseInt( wprice * 0.1));
        var TTT = IntvalGet(sooTax - OKN);
        if( document.getElementById("billstatus_5").checked == true) sooTax = wprice;
        document.getElementById("billPrice").value = Util.formatNumber(sooTax);
        document.getElementById("paystate_worktotal").value = Util.formatNumber(sooTax); ///// 총금액자리
        document.getElementById("paystate_misoo").value = Util.formatNumber(TTT);
        if(document.getElementById("multiFormTd_sprice"))document.getElementById("multiFormTd_sprice").innerHTML = Util.formatNumber(wprice);
        if(document.getElementById("multiFormTd_after")) document.getElementById("multiFormTd_after").innerHTML = Util.formatNumber(sooTax);
        var TaxTotal = parseInt( soo * 0.1);
        if( TaxTotal < 0 ) TaxTotal = 0;
        document.getElementById("totalTax").value = Util.formatNumber(TaxTotal);
    }
}

export default class PaymentSettle {
    payTypeSetToNew = payTypeSetToNew;
    payat_misoocheck = payat_misoocheck;
    get_lastMisoo = get_lastMisoo;
    get_number_only = get_number_only;
    base_priceput_new = base_priceput_new;
    pstCh = pstCh;
    payOkset = payOkset;
    multiPle_priceTotalGetShow = multiPle_priceTotalGetShow;
}
